import { createReducer, on } from '@ngrx/store';

import { changeSearchTypes } from '../search-all-params/search-all-params.actions';

import { SearchAllCategory } from 'SearchApp/ts/types/search-all-category.type';

export const searchTypes = createReducer(
    [] as SearchAllCategory[],
    on(changeSearchTypes, (state: SearchAllCategory[], action) => {
        return action.searchTypes;
    })
);
